import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import Dropdown from '@lib/inputs/Dropdown';
import Input from '@lib/inputs/Input';
import { GridStyledWrapper } from '../voterRegistration.styled';
import { VoterRegistrationFormError } from '../VoterRegistrationFormError';
import useVoterRegistration from '../useVoterRegistration';
import { IVoterRegistrationFormValues } from '../voterRegistrationTypes';

function ApplicantInformationSection() {
    const intl = useIntl();
    const {
        watch,
        formState: { errors },
        setValue,
    } = useFormContext();

    const { VOTER_REGISTRATION_CHOICES } = useVoterRegistration();

    const handleFieldChange = (name: keyof IVoterRegistrationFormValues, value: string) => {
        setValue(name, value, {
            shouldValidate: true,
            shouldDirty: true,
        });
    };

    return (
        <>
            <FormattedMessage id="voterRegistration.form.applicantName" tagName="h2" />
            <GridStyledWrapper>
                <div id="firstName-section">
                    <Input
                        label={{
                            text: intl.formatMessage({ id: 'voterRegistration.form.firstName' }),
                        }}
                        inputData={{
                            id: 'firstName',
                            isInputRequired: true,
                            value: watch('firstName'),
                        }}
                        inputActions={{
                            handleFieldChange: val => handleFieldChange('firstName', val),
                        }}
                    />
                    <VoterRegistrationFormError
                        name="firstName"
                        hasError={!!errors.firstName}
                        messageId={errors.firstName?.message}
                    />
                </div>
                <div id="lastName-section">
                    <Input
                        label={{
                            text: intl.formatMessage({ id: 'voterRegistration.form.lastName' }),
                        }}
                        inputData={{
                            id: 'lastName',
                            isInputRequired: true,
                            value: watch('lastName'),
                        }}
                        inputActions={{
                            handleFieldChange: val => handleFieldChange('lastName', val),
                        }}
                    />
                    <VoterRegistrationFormError
                        name="lastName"
                        hasError={!!errors.lastName}
                        messageId={errors.lastName?.message}
                    />
                </div>
                <div id="middleName-section">
                    <Input
                        label={{
                            text: intl.formatMessage({ id: 'voterRegistration.form.middleName' }),
                        }}
                        inputData={{
                            id: 'middleName',
                            value: watch('middleName'),
                        }}
                        inputActions={{
                            handleFieldChange: val => handleFieldChange('middleName', val),
                        }}
                    />
                    <VoterRegistrationFormError
                        name="middleName"
                        hasError={!!errors.middleName}
                        messageId={errors.middleName?.message}
                    />
                </div>
                <div id="suffix-section">
                    <Dropdown
                        label={{
                            text: intl.formatMessage({ id: 'voterRegistration.form.suffix.title' }),
                        }}
                        inputData={{
                            id: 'suffix',
                            isInputRequired: false,
                            value: watch('suffix'),
                            options: VOTER_REGISTRATION_CHOICES.SUFFIX,
                        }}
                        inputActions={{
                            handleFieldChange: val => handleFieldChange('suffix', val),
                        }}
                    />
                    <VoterRegistrationFormError
                        name="suffix"
                        hasError={!!errors.suffix}
                        messageId={errors.suffix?.message}
                    />
                </div>
            </GridStyledWrapper>
        </>
    );
}

export default ApplicantInformationSection;
